import BaseViewController from "./base-view-controller";

class SearchMedicationViewController extends BaseViewController {
  handleSelectChange({ term }) {
    const { data, screenIndex, values, nextScreen } = this.appData;
    nextScreen({
      data,
      screenIndex,
      screenParams: {
        drug_cd: term.code,
        drug_type_cd: term.code_type
      },
      formState: {
        ...values,
        medication_name: term.name,
        medication_dosage: "",
        medication_frequency: "",
        statusQuestion: "Y"
      },
      action: {
        type: "screen",
        value: "AddMedication"
      }
    });
  }
}

export default SearchMedicationViewController;
